<section class="tw-flex">
  <button
    mhFilterTrigger
    [filterOpen]="isOpen"
    (click)="isOpen = !isOpen"
    cdkOverlayOrigin #trigger="cdkOverlayOrigin"
  >
    <!-- En móvil el control es un círculo con solo el ícono -->
    <i class="fas fa-search tw-text-neutral-500 xs:tw-hidden"></i>
    <i class="fas fa-clipboard-list tw-hidden tw-text-neutral-500 xs:tw-inline-block md:tw-hidden"></i>
    <span class="tw-hidden tw-max-w-64 tw-truncate md:tw-block">
      {{ 'core-lib.selectors.competitors.button' | translate: { competitor: competitorSelected } }}
    </span>
    <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
  </button>

  <button
    mhFilterTrigger
    [filterIconOnly]="true"
    class="tw-ml-3"
    *ngIf="hasActiveFilters"
    (click)="cleanFilters()"
  >
    <span class="tw-relative tw-inline-flex">
      <i class="fas fa-filter tw-text-neutral-500 xs:tw-hidden"></i>
      <i class="fas fa-clipboard-list tw-hidden tw-text-neutral-500 xs:tw-inline-block"></i>
      <i class="fas fa-times-circle tw-absolute -tw-right-1.5 -tw-top-1 tw-text-[9px] tw-text-red-500"></i>
    </span>
  </button>
</section>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPanelClass]="['tw-top-[22%]', 'tw-left-[8%]', 'sm:tw-left-[inherit]']"
>
  <div>
    <article id="overlaySelectorGuest" class="tw-mt-3">
      <mh-core-lib-generic-box>
        <mh-core-lib-autocomplete-input
            [options]="competitors"
            [openBox]="true"
            [filterFn]="autocompleteFilterFn"
            [showGlassIcon]="true"
            [displayOptionsFn]="displayHotelOptions"
            (optionSelected)="handleCompetitorSelected($event)"
            >
        </mh-core-lib-autocomplete-input>
      </mh-core-lib-generic-box>
    </article>
  </div>
</ng-template>
